import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtKanaBehavior } from "./PtKanaBehavior";

/** HIS項目患者ふりがなを生成する */
export class PtKanaHiraganaBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA_HIRAGANA";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtKanaHiraganaBehavior.Key).map(x => x.value);
    const behavior = new PtKanaBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const hiragana = values.map(x => StringUtility.convertKatakanaToHiragana(x));
    const data = itemValues.length > 0 ? itemValues : hiragana;
    return new HisInformationTextValue(PtKanaHiraganaBehavior.Key, data);
  }
}
